import Quill from "quill";
import * as notification from '../components/notifications';
import trans from "./trans";

export function initTextEditor(container = 'quill-container', textElement = 'v-description') {
  let containerSelector = '#' + container;
  if ($(containerSelector).length === 0) {
    return;
  }

  const isInitiated = $(containerSelector).attr('is-initiated');

  if (isInitiated) {
    return;
  }

  $(containerSelector).attr('is-initiated', true);

  const quill = new Quill(containerSelector, {
    theme: 'snow',
    placeholder: $(containerSelector).data('placeholder'),
    modules: {
      clipboard: {
        matchVisual: false,
      },
      // @NOTE: The following configuration also used in the main application/SAAS app, if you update this, CHECK if
      // the config in job-view.js also needs to be updated
      toolbar: [
        // [{ size: ["small", false, "large", "huge"] }],

        ["bold", "italic", "underline", "strike"],

        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],

        [{list: "ordered"}, {list: "bullet"}],

        // [{ indent: "-1" }, { indent: "+1" }],

        ["link"],
        ["clean"],
        ["image"]
      ]
    },
  });

  const handleUploadImage = function () {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.click();

    input.onchange = () => {
      const file = input.files[0];

      if (/^image\//.test(file.type)) {
        const formData = new FormData();
        formData.append("file", file);

        axios.post($jBoard.config.main_api_url + '/images/Editor', formData,
          {
            headers:
              {
                "X-Use-Team-Trans": 'true',
                "X-Team-ID": $jBoard.team.id
              }
          }).then(result => {
          const url = result.data.url;
          embedToEditor(url)
        })
          .catch(error => {
            let errors = error.response?.data?.errors;
            if (errors && typeof errors.file != 'undefined') {
              notification.danger(errors.file.join(', '));
            } else {
              notification.danger(error.message)
            }
          });
      } else {
        notification.danger(trans('general.error.upload_only_image'));
      }
    };
  }

  const embedToEditor = function (url) {
    const range = quill.getSelection();
    quill.insertEmbed(range.index, 'image', url);
  }

  quill.getModule("toolbar").addHandler("image", handleUploadImage);

  quill.on('text-change', function () {
    $('#' + textElement).val(quill.root.innerHTML);
  });
}

export function getTextEditorInstance(container = 'quill-container') {
  const containerElement = $('#' + container)[0];

  if (!containerElement) {
    return null;
  }

  return containerElement.__quill || Quill.find(containerElement);
}

export function typeHtmlIntoEditor(container, html, {interval = 10, chunkSize = 3, onDone} = {}) {
  const quill = getTextEditorInstance(container);

  if (!quill) {
    return null;
  }

  const Delta = Quill.import('delta');
  const fullDelta = quill.clipboard.convert(html);

  quill.setText('');

  const queue = [];

  fullDelta.ops.forEach((op) => {
    if (typeof op.insert !== 'string') {
      queue.push(op);
      return;
    }

    let buffer = '';
    const flush = () => {
      if (buffer) {
        queue.push({insert: buffer, attributes: op.attributes});
        buffer = '';
      }
    };

    for (const char of op.insert) {
      if (char === '\n') {
        flush();
        queue.push({insert: '\n', attributes: op.attributes});
      } else {
        buffer += char;
        if (buffer.length >= chunkSize) {
          flush();
        }
      }
    }
    flush();
  });

  // The empty editor already ends with a newline; a plain trailing '\n' from the
  // converted HTML would only add an empty line under the text.
  const lastOp = queue[queue.length - 1];
  if (lastOp && lastOp.insert === '\n' && !lastOp.attributes) {
    queue.pop();
  }

  let insertedLength = 0;
  let done = false;
  let timer = null;

  const finish = (stopped) => {
    if (done) {
      return;
    }

    done = true;
    clearInterval(timer);

    if (onDone) {
      onDone(stopped);
    }
  };

  const insertNext = () => {
    const op = queue.shift();

    if (!op) {
      finish(false);
      return false;
    }

    quill.updateContents(new Delta().retain(insertedLength).insert(op.insert, op.attributes || {}));
    insertedLength += typeof op.insert === 'string' ? op.insert.length : 1;

    return true;
  };

  timer = setInterval(insertNext, interval);

  return {
    stop() {
      finish(true);
    },
    complete() {
      while (!done && insertNext()) {
        // inserts the remaining chunks in one go
      }
    },
  };
}

export function clearTextEditor(container = 'quill-container') {
  const quill = getTextEditorInstance(container);

  if (quill) {
    quill.setContents([]);
  }
}

export function setTextEditorText(container, text) {
  const quill = getTextEditorInstance(container);

  if (quill) {
    quill.setText(text);
  }
}

$(function () {
  initTextEditor();

  document.addEventListener('jb.section.rendered', () => {
    initTextEditor();
  });
});
